<main class="page-main">
    <app-page-sub-nav [data]="pageSubNavData" [currVisible]="currVisible"></app-page-sub-nav>
    <section class="page-section" id="overview">
        <h2 id="sectionTitleOverview" class="page-section-title" title="Copy Link to Clipboard"
            (click)="copyToClipboard('overview')">
            Overview <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
        </h2>
        <ul class="page-section-list">
            <li class="page-section-list-item">
                The use of color in an experience helps define communication, meaning, brand, and roles, making it easier for users to interact, search, and differentiate elements.  
            </li>
            <li class="page-section-list-item">
                Our color palette is designed to be flexible enough to handle a variety of contexts—from digital interfaces to marketing materials—while maintaining a consistent 
                brand feel. We focus on accessibility and scalability so that our product can be used by a wide audience in both light and dark modes.   
            </li>
        </ul>
    </section>
    <section class="page-section" id="usage">
        <h2 id="sectionTitleFirst" class="page-section-title" title="Copy Link to Clipboard"
            (click)="copyToClipboard('usage')">
            Usage guidelines <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
        </h2>
        <section class="page-sub-section" id="usage-general">
            <h3 id="subSectionTitleFirstA" class="page-sub-section-title" title="Copy Link to Clipboard"
                (click)="copyToClipboard('usage-general')">
                General <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
            </h3>
            <ul class="page-section-list">
                <li class="page-section-list-item">
                    This color palette was designed to accommodate BeyondTrust’s vast range of products. The use cases are recommendations. 
                </li>
                <li class="page-section-list-item">
                    The guidelines on this page outline the general use of color. For color guidance related to specific components, visit the component-specific guidelines. 
                </li>
                <li class="page-section-list-item">
                    Light and Dark palette colors are not to be mixed and matched. Use light colors palette only for light mode and dark color palette only for dark mode.   
                </li>
            </ul>
        </section>
    </section>
    <section class="page-section" id="variations">
        <h2 id="sectionTitleSecond" class="page-section-title" title="Copy Link to Clipboard"
            (click)="copyToClipboard('variations')">
            Themes <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
        </h2>
        <ul class="page-section-list">
            <li class="page-section-list-item">
                The large majority of BeyondTrust's products provide both a light and dark color theme. 
                Certain colors which may be suitable for the light theme may not translate well to the dark mode theme and vice versa. As such, appropriate alternatives must be provided where necessary.     
            </li>
            <li class="page-section-list-item">
                <img src="\assets\images\redlines\color\light_vs_dark.png" alt="ligh vs dark color" style="width: 900px"/>   
            </li>
        </ul>
        <section class="page-sub-section" id="variations-light">
            <h3 id="subSectionTitleFirstA" class="page-sub-section-title" title="Copy Link to Clipboard"
                (click)="copyToClipboard('variations-light')">
                Light theme <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
            </h3>
            <ul class="page-section-list">
                <li class="page-section-list-item">
                    <img src="\assets\images\redlines\color\light_mode.png" alt="ligh color" style="width: 900px" />
                <!-- <span class="redlines-caption">Light mode palette</span> -->
                </li>
            </ul>
        </section>
        <section class="page-sub-section" id="variations-dark">
            <h3 id="subSectionTitleFirstA" class="page-sub-section-title" title="Copy Link to Clipboard"
                (click)="copyToClipboard('variations-dark')">
                Dark theme <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
            </h3>
            <ul class="page-section-list">
                <li class="page-section-list-item">
                    <img src="\assets\images\redlines\color\dark_mode.png" alt="dark color" style="width: 900px"/>
                    <!-- <span class="redlines-caption">Dark mode palette</span> -->
                </li>
            </ul>
        </section>
        <section class="page-sub-section" id="variations-accents">
            <h3 id="subSectionTitleFirstA" class="page-sub-section-title" title="Copy Link to Clipboard"
                (click)="copyToClipboard('variations-accents')">
                Accent <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
            </h3>
            <ul class="page-section-list">
                <li class="page-section-list-item">
                    Accent colors are used to emphasize and accentuate components in various states, such as the focus state of buttons.               
                </li>
                <li class="page-section-list-item">
                    <img src="\assets\images\redlines\color\accents.png" alt="accent color" style="width: 900px" />
                    <!-- <span class="redlines-caption">Text/link palette</span> -->
                </li>
            </ul>
        </section>
        <section class="page-sub-section" id="variations-data">
            <h3 id="subSectionTitleFirstA" class="page-sub-section-title" title="Copy Link to Clipboard"
                (click)="copyToClipboard('variations-data')">
                Data visualization <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
            </h3>
            <ul class="page-section-list">
                <li class="page-section-list-item">
                    <img src="\assets\images\redlines\color\data_visualization.png" alt="data visualization color" style="width: 900px" />
                    <!-- <span class="redlines-caption">Data visualization palette</span> -->
                </li>
            </ul>
        </section>
        <section class="page-sub-section" id="variations-severity">
            <h3 id="subSectionTitleFirstA" class="page-sub-section-title" title="Copy Link to Clipboard"
                (click)="copyToClipboard('variations-severity')">
                Severity and status <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
            </h3>
            <ul class="page-section-list">
                <li class="page-section-list-item">
                    <img src="\assets\images\redlines\color\feedback.png" alt="severity and status color" style="width: 900px"/>
                    <!-- <span class="redlines-caption">Severity and status palette</span> -->
                </li>
            </ul>
        </section>
    </section>
    <section class="page-section" id="accessibility">
        <h2 id="sectionTitleThird" class="page-section-title" title="Copy Link to Clipboard"
            (click)="copyToClipboard('accessibility')">
            Accessibility <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
        </h2>
        <ul class="page-section-list">
            <li class="page-section-list-item">
                Accessibility considerations for color are very important: make sure your colors meet accessibility guidelines.    
            </li>
            <li class="page-section-list-item">
                The two primary accessibility concerns are maintaining proper contrast ratios and making sure color is not used as the only method to define meaning in an experience.   
            </li>
            <li class="page-section-list-item">
                <b>Avoid relying solely on color to differentiate between objects, indicate interactivity, or communicate essential information. </b>
                When you use color to convey information, be sure to provide the same information in alternative ways so people with color blindness or 
                other visual impairments can understand it. For example, you can use labels or glyph shapes to identify objects or states. 
            </li>
            <li class="page-section-list-item">
                <a href="https://www.w3.org/TR/WCAG21/#contrast-minimum">WCAG Level AA compliant contrast ratios</a> create a more accessible experience in our products. 
                It ensures that our text, labels and controls are adequately legible, especially for sight impaired individuals. 
            </li>
        </ul>
        <section class="page-sub-section" id="accessibility-wcag">
            <h3 id="subSectionTitleThirdA" class="page-sub-section-title" title="Copy Link to Clipboard"
                (click)="copyToClipboard('accessibility-wcag')">
                WCAG 2.0 Level AA Contrast Requirements  <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
            </h3>
            <ul class="page-section-list">
                <li class="page-section-list-item">
                    <ul class="page-section-do-list">
                        <li class="page-section-list-item">
                            <b>Normal Text</b> must have a contrast ratio of at least <b>4.5:1</b> 
                        </li>
                        <li class="page-section-list-item">
                            <b>Large Text</b> must have a contrast ratio of at least <b>3:1</b> 
                            <ul class="page-section-sub-do-list">
                                <li class="page-section-list-item">Large text is defined as 14 point (typically 18.66px) and bold or larger, or 18 point (typically 24px) or larger. </li>
                            </ul>
                        </li>
                        <li class="page-section-list-item">
                            <b>Graphics and UI Elements</b> must have a contrast ratio of at least <b>3:1</b> 
                        </li>
                    </ul>
                </li>
            </ul>
            <ul class="page-section-list">
                <li class="page-section-list-item">
                    Use the <a href="https://webaim.org/resources/contrastchecker/">WebAIM Contrast Checker Tool</a> to ensure the colors you are using are WCAG Level AA compliant.  
                </li>
            </ul>
        </section>
    </section>
    <!-- <section class="page-section" id="resources">
        <h2 id="sectionTitleResources" class="page-section-title" title="Copy Link to Clipboard"
            (click)="copyToClipboard('resources')">
            Resources <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
        </h2>

        <ul class="page-section-list">
            <li class="page-section-list-item resource-list-item">
                <a href="" target="_blank">Article name placeholder</a><span class="resource-source">Owner Name</span>
            </li>
            <li class="page-section-list-item resource-list-item">
                <a href="https://www.krishaweb.com/blog/outline-icons-vs-solid-icons-which-are-faster-to-recognize-and-when/"
                    target="_blank">Outline Icons vs. Solid Icons: Which are Faster to
                    Recognize and When?</a><span class="resource-source">KrishaWeb</span>
            </li>
        </ul>
    </section> -->
    <!-- <section class="page-section" id="related">
        <h2 id="sectionTitleRelated" class="page-section-title" title="Copy Link to Clipboard"
            (click)="copyToClipboard('related')">
            Related <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
        </h2>
        <span class="page-related-list-title">Referenced in this section:</span>
        <ul class="page-section-list page-related-list">
            <li class="page-related-list-item">
                <a href="components/overview">Placeholder component</a>
            </li>
            <li class="page-related-list-item">
                <a href="guidelines/overview">Placeholder guidelines</a>
            </li>
            <li class="page-related-list-item">
                <a href="patterns/overview">Placeholder pattern</a>
            </li>
        </ul>

        <span class="page-related-list-title">Components and patterns that use
            branding guidelines:</span>
        <ul class="page-section-list page-related-list">
            <li class="page-related-list-item">
                <a href="components/overview">Placeholder component</a>
            </li>
            <li class="page-related-list-item">
                <a href="patterns/overview">Placeholder pattern</a>
            </li>
        </ul>
    </section> -->
    <section class="page-section" id="history">
        <h2 id="sectionTitleHistory" class="page-section-title" title="Copy Link to Clipboard"
            (click)="copyToClipboard('history')">
            Revision history <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
        </h2>
        <ul class="page-history-list">
            <li class="page-history-list-item" *ngFor="
						let subItem of changelogService.getChangelogBySection(
							'Colors Guidelines'
						)
					">
                <span class="page-history-list-item-title">{{
                    changelogService.formatDate(subItem.changeDate)
                    }}</span>
                <a class="page-history-list-item-link" target="_blank" *ngIf="subItem.workId != ''" [attr.href]="
							'https://beyondtrust.atlassian.net/jira/software/c/projects/SDS/issues/' +
							subItem.workId
						">[{{ subItem.workId }}]</a>{{ subItem.changeName }}
            </li>
        </ul>
    </section>
</main>